import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // 政企平台
  {
    path: '/ZQPlatform',
    name: 'ZQPlatform',
    component: () =>
      import(
        /* webpackChunkName: "XkPlatform" */ '../views/XkPlatform/ZQPlatform.vue'
      )
  },
  // 政务平台
  {
    path: '/ZWPlatform',
    name: 'ZWPlatform',
    component: () =>
      import(
        /* webpackChunkName: "XkPlatform" */ '../views/XkPlatform/ZWPlatform.vue'
      )
  },
  // 业财一体化
  {
    path: '/YCPlatform',
    name: 'YCPlatform',
    component: () =>
      import(
        /* webpackChunkName: "XkPlatform" */ '../views/XkPlatform/YCPlatform.vue'
      )
  },
  // 费控平台
  {
    path: '/FKPlatform',
    name: 'FKPlatform',
    component: () =>
      import(
        /* webpackChunkName: "XkPlatform" */ '../views/XkPlatform/FKPlatform.vue'
      )
  },
  // 会议机
  {
    path: '/Machine',
    name: 'Machine',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/LearningProducts/Machine.vue'
      )
  },
  // 高拍仪
  {
    path: '/HighShotMeter',
    name: 'HighShotMeter',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/LearningProducts/HighShotMeter.vue'
      )
  },
  // 录音笔
  {
    path: '/VoiceRecorder',
    name: 'VoiceRecorder',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/LearningProducts/VoiceRecorder.vue'
      )
  },
  // 翻译笔
  {
    path: '/TranslationMachine',
    name: 'TranslationMachine',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/LearningProducts/TranslationMachine.vue'
      )
  },
  // 学习机
  {
    path: '/LearningMachine',
    name: 'LearningMachine',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/LearningProducts/LearningMachine.vue'
      )
  },
  // 会参谋
  {
    path: '/WillStaff',
    name: 'WillStaff',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/LearningProducts/WillStaff.vue'
      )
  },
  // 小科金融
  {
    path: '/XKFinancial',
    name: 'XKFinancial',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/XKFinancial.vue')
  },
  // 软件解决方案
  {
    path: '/SoftwareSolutions',
    name: 'SoftwareSolutions',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/SoftwareSolutions.vue')
  },
  // 联系我们
  {
    path: '/ContactUs',
    name: 'ContactUs',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ContactUs.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
